import { inject } from '@angular/core';
import Keycloak from 'keycloak-js';
import {
	DbConnectionConfig,
	GatewayDbConnection,
	keycloakBearerTokenProvider,
	keycloakTokenRefresher,
} from '@luzula/luzula-lib';
import { environment } from '../../environments/environment';

/**
 * DB_CONNECTION_CONFIGS-Factory (via `useFactory` in app-providers.ts). Nutzt die
 * ZENTRALE {@link GatewayDbConnection} der Lib mit dem Standard-Bearer-Token-Provider
 * ({@link keycloakBearerTokenProvider}, inkl. Fallback auf den persistierten kc-token).
 *
 * `isAuthenticated` haengt an der SESSION-Existenz (`kc.authenticated`), NICHT am
 * momentanen Token: waehrend Init/Refresh ist `kc.token` kurz leer, obwohl eingeloggt —
 * ein definitiv ausgeloggter User (=== false) bekommt den oeffentlichen Read-Only-Pfad.
 */
export function buildDbConnectionConfigs(): DbConnectionConfig[] {
	const env = environment as { apiBaseUrl: string; dbAppName?: string };
	const kc = inject(Keycloak);
	return [
		new GatewayDbConnection(
			env.apiBaseUrl,
			env.dbAppName ?? 'bpweb',
			keycloakBearerTokenProvider(),
			() => kc.authenticated,
			keycloakTokenRefresher(),
		),
	];
}
